module.exports = __webpack_public_path__ + "static/fcra-2018-19-q2-648ebabef96ae4939a6cfb7cfc114808.pdf";